import React, { Component } from 'react';
import Icon from '../../icons/Icon';
import ComponentName from '../../constant/ComponentName';
import RoleHelper from '../../RoleHelper';
import { RootState } from '../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { FormicaProps, withFormica } from 'helpers/withFormica';
import { SidebarMenuItemProps } from './SidebarMenuItem';
import SidebarMenuItemContainer from './SidebarMenuItemContainer';
import EnvironmentUtil from '../../util/EnvironmentUtil';
import { InstanceContainer } from '../../config/binding/InstanceBinding';
import Injectables from '../../constant/Injectables';
import LanguageUtil from '../../util/LanguageUtil';

class IntegrationMenu extends Component<Props> {
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private integration: SidebarMenuItemProps[] = [
    {
      name: LanguageUtil.get({ id: 'common.label.dashboard', defaultMessage: 'Dashboard' }),
      field: 'Dashboard',
      path: 'dashboard',
      icon: <Icon icon='sidebar-dashboard' className={'text-f-black-2 group-hover:text-primary'} size={14} />,
      children: [],
      component: ComponentName.DASHBOARD,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.ach', defaultMessage: 'ACH' }),
      field: 'ACH',
      path: 'ach',
      icon: <Icon icon={'sidebar-ach'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.ACH,
      visible: this.environmentUtil.getAch(),
    },
    {
      name: LanguageUtil.get({ id: 'common.label.transaction', defaultMessage: 'Transaction' }),
      field: 'Cases',
      path: 'cases',
      icon: <Icon icon={'sidebar-transaction'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.CASE,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.entity', defaultMessage: 'Entity' }),
      field: 'Entity',
      path: 'entity',
      icon: <Icon icon={'entity'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.ENTITY,
      visible: this.environmentUtil.getPages().entity,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.graph', defaultMessage: 'Graph' }),
      field: 'Graph',
      path: 'graph',
      icon: <Icon icon={'sidebar-graph'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.GRAPH,
    },
    {
      name: LanguageUtil.get({ id: 'common.label.configuration', defaultMessage: 'Configuration' }),
      field: 'CaseConfiguration',
      path: 'configuration',
      icon: <Icon icon={'sidebar-settings'} className={'text-f-black-2 group-hover:text-primary'} size={16} />,
      children: [],
      component: ComponentName.CONFIGURATION,
    },
  ];

  public render() {
    const { collapsed, goPage, router } = this.props;

    const filteredIntegrations = this.integration.filter((m) => (m.visible != undefined ? m.visible : true) && RoleHelper.canView(m.field));
    const pathName = router.location.pathname.split('/')[1];

    if (filteredIntegrations?.length == 0) {
      return;
    }
    return (
      <SidebarMenuItemContainer
        items={filteredIntegrations}
        goPage={goPage}
        pathName={pathName}
        collapsed={collapsed}
        title={LanguageUtil.get({ id: 'common.label.investigationTitle', defaultMessage: 'INVESTIGATION' })}
        collapsedTitle={'I'}
      />
    );
  }
}

interface Props extends ReduxProps, FormicaProps {
  goPage(m: SidebarMenuItemProps): void;
}

const mapStateToProps = (state: RootState) => ({
  collapsed: state.page.sidebarCollapsed,
  page: state.page,
  component: state.component,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default withFormica(connector(IntegrationMenu));
